import { render, staticRenderFns } from "./CompanyBuilder.vue?vue&type=template&id=314b46fa&scoped=true"
import script from "./CompanyBuilder.vue?vue&type=script&lang=js"
export * from "./CompanyBuilder.vue?vue&type=script&lang=js"
import style0 from "./CompanyBuilder.vue?vue&type=style&index=0&id=314b46fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314b46fa",
  null
  
)

export default component.exports